/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{


  phina.define('phina.display.LabelArea2', {
    superClass: 'phina.display.DisplayElement',
    init: function(param) {
      param=(param||{}).$safe(phina.display.LabelArea2.default)
      this.superInit(param)
  
      this.label = phina.display.LabelArea(param)
      .addChildTo(this)
  
      this.on('changed', this.showText.bind(this))
    },
    showText: function(){
      let appendText = ''
      if(this.text.startsWith(this.label.text)){
        appendText = this.text.substr(this.label.text.length)
      }else{
        this.label.text = ''
        appendText = this.text
      }
      this.tweener.clear()
      let text = ''
      let scroll = 0
      appendText.each((c, i)=>{
        if(i%3==2){
          this.tweener.wait(100)
        }
        text += c
        var lines = this.spliceLines((text + '').split('\n'))
        if(this.label.lineSize * lines.length - scroll > this.label.height){
          //scrollは逆方向なので行数-1
          let _scroll = scroll = this.label.lineSize * (lines.length-1)
          this.tweener
            .wait(4000)
            .call(()=>{
              this.label.tweener
                .clear()
                .to({ scrollY: _scroll },750,'easeOutCubic')
            })
            .call(()=>{
              this.label.text += c
            })
        }else{
          this.tweener
            .call(()=>{
              this.label.text += c
            })
        }
      })
      this.tweener
        .call(()=>{ this.flare('showed') })
    },
    spliceLines: function(lines) {
      var rowWidth = this.label.width;
      var context = this.label.canvas.context;
      context.font = this.label.font;
  
      var cache = this.label.getTextWidthCache();
      
      var localLines = [];
      lines.forEach(function(line) {
        // update cache
        line.each(function(ch) {
          if (!cache[ch]) {
            cache[ch] = context.measureText(ch).width;
          }
        });
        
        var str = '';
        var totalWidth = 0;
  
        // はみ出ていたら強制的に改行する
        line.each(function(ch) {
          var w = cache[ch];
  
          if ((totalWidth+w) > rowWidth) {
            localLines.push(str);
            str = '';
            totalWidth = 0;
          }
  
          str += ch;
          totalWidth += w;
        });
  
        // 残りを push する
        localLines.push(str);
  
      });
      
  
      return localLines;
    },
  _accessor: {
      visibleText: {
        get: function(){ return this.label.text }
      },
      text:{
        get: function(){ return this._body },
        set: function(v){
          this._body = v 
          this.label.scrollY = 0
          this.flare('changed')
        }
      }
    },
    _static: {
      default: {
        animation: true
      }
    }
  })
  
}